import React from 'react';
import { TimeFrame } from 'models/ReportData';
import { formatSecToHourString } from 'helpers/conversions';
import { ITopCardsProps } from './TopCardsContainer';
import { Box } from '@mui/material';
import { chartIcon, dashboardIcon, likeIcon, productionIcon } from '../Icons';
import TotalImpressionCardMobileApollo from '../TotatImpressionCardMobile';
import ProductionRateCardMobileApollo from '../ProductionRateCardMobileApollo';
import ProductivityCardMobileApollo from '../ProductivityCardMobileApollo';
import AvailabilityCardMobileApollo from '../AvailabilityCardMobileApollo';
import { styles } from './OverviewTopCard.styles';

const MobileApolloTopCards = (props: ITopCardsProps) => {
  const {
    timeframe,
    totalProduction,
    productionTrend,
    productionRate,
    productionRateTrend,
    loadingTime,
    loadingTimeTrend,
    productivity,
    productivityChange,
    availability,
    availabilityTrend,
    errorDuration,
    errorDurationTrend,
    maintenanceDuration,
    maintenanceDurationTrend,
    selectedSystemGroup,
    selectedSystemGroupText,
    units,
    isProductionMode,
  } = props;
  const getTimeframeTextKey = () => {
    return timeframe && timeframe.includes('lastUpdate') ? 'last' : 'weekDay';
  };
  const changeTextPerPage = (timeframe: TimeFrame | '', text: string) => {
    if (timeframe && timeframe.includes('lastUpdate')) return text.replace('Average', 'Current');
    return text;
  };
  return (
    <>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <TotalImpressionCardMobileApollo
          value={totalProduction}
          units={units}
          icons={productionIcon(selectedSystemGroup)}
          description={selectedSystemGroupText.impression.description[getTimeframeTextKey()]}
          stats={productionTrend}
          statsDescription={selectedSystemGroupText.impression.statsDescription[getTimeframeTextKey()]}
          cardName="totalProduction"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <ProductionRateCardMobileApollo
          selectedSystemGroup={selectedSystemGroup}
          value={productionRate}
          units={units + '/h'}
          icons={dashboardIcon}
          description={
            isProductionMode
              ? selectedSystemGroupText.productionRate.descriptionProduction
              : selectedSystemGroupText.productionRate.description[getTimeframeTextKey()]
          }
          stats={productionRateTrend}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          cardName="averageProductionRate"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <ProductivityCardMobileApollo
          selectedSystemGroup={selectedSystemGroup}
          value={productivity}
          units={units + '/h'}
          icons={chartIcon}
          description={
            isProductionMode
              ? selectedSystemGroupText.utilization?.descriptionProduction
              : 'Productivity'
          }
          stats={productivityChange}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: 'sec/' + units,
              value: loadingTime,
              description: changeTextPerPage(timeframe, selectedSystemGroupText.productionRate.upper),
              trend: loadingTimeTrend,
            },
          }}
          cardName="productivity"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <AvailabilityCardMobileApollo
          cardName="availability"
          value={availability}
          units={'%'}
          icons={likeIcon}
          isPercentage={true}
          description={
            isProductionMode
              ? selectedSystemGroupText.availability.descriptionProduction
              : selectedSystemGroupText.availability.description[getTimeframeTextKey()]
          }
          stats={availabilityTrend}
          statsDescription={
            selectedSystemGroupText.availability.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '',
              value: errorDuration,
              description: selectedSystemGroupText.availability.upper,
              trend: errorDurationTrend,
              formatter: formatSecToHourString,
            },
            lower: {
              value: maintenanceDuration,
              unit: '',
              description: selectedSystemGroupText.availability.lower,
              trend: maintenanceDurationTrend,
              formatter: formatSecToHourString,
            },
          }}
        />
      </Box>
    </>
  );
};

export default MobileApolloTopCards;
